var _rect, _path, _circle, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketingCampaigns(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "m3",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#4f46e5"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 14,
    fill: "#f1f5f9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 44V24l6 4 8-6 8 8 10-10v24H16z",
    fill: "url(#m3)",
    opacity: 0.88
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 30,
    r: 3,
    fill: "#fff",
    opacity: 0.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 26,
    r: 3,
    fill: "#fff",
    opacity: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 32,
    r: 3,
    fill: "#fff",
    opacity: 0.55
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 22,
    r: 3,
    fill: "#fff",
    opacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingCampaigns);
export default __webpack_public_path__ + "static/media/marketing-campaigns.6a3769813017014fb69d23b0243f1446.svg";
export { ForwardRef as ReactComponent };